import { ExposureLevel } from '../enum/EnumRepository';

/** `ExposureLevel.isAccessible()` */
export function isExposureLevelAccessible(level: ExposureLevel): boolean {
  return level !== ExposureLevel.PRIVATE;
}

/** `ExposureLevel.isSearchable()` — SEARCHABLE, PUBLIC */
export function isExposureLevelSearchable(level: ExposureLevel): boolean {
  return level === ExposureLevel.SEARCHABLE || level === ExposureLevel.PUBLIC;
}

/** `ExposureLevel.isRecommendable()` — PUBLIC 만 true */
export function isExposureLevelRecommendable(level: ExposureLevel): boolean {
  return level === ExposureLevel.PUBLIC;
}
